import { ElementRef } from '@angular/core';
import { NotificationService } from 'src/app/shared/notificaton.service';
import { GoogleSettingsService } from './google-settings.service';
import { GoogleSettings } from './google-settings';
declare var google: any;
declare var tokenClient: any;
declare var pickerInited: boolean;

export class GoogleDriveService {
    private accessToken = '';
    private filePickedCallback: Function;

    constructor(private notifier: NotificationService, filePickedCallback: Function, private document, private elementRef: ElementRef, private googleSettingsService: GoogleSettingsService) {
        this.filePickedCallback = filePickedCallback;
    }

    private libsAreLoaded(): boolean {
        return pickerInited && tokenClient;
    }

    public addScriptInclude() {
        const scriptTag = this.document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        const self = this;
        scriptTag.onload = function () { self.gisLoadedHandler(); };
        this.elementRef.nativeElement.appendChild(scriptTag);
    }

    gisLoadedHandler() {
        if (tokenClient) {
            return;
        }
        console.log('gisLoaded');
        const SCOPES = 'https://www.googleapis.com/auth/drive.file';
        this.googleSettingsService.getSettings().then(settings => {
            tokenClient = google.accounts.oauth2.initTokenClient({
                client_id: settings.clientId,
                scope: SCOPES,
                callback: '', // defined later
            });
        });
    }

    pickAndDownloadFile() {
        if (!this.libsAreLoaded()) {
            this.notifier.showError('Google libraries are not loaded yet, please try again few seconds later.');
            return;
        }

        tokenClient.callback = async (response) => {
            if (response.error !== undefined) {
                throw (response);
            }
            this.accessToken = response.access_token;
            console.log('token:');
            console.log(this.accessToken);
            var settings = await this.googleSettingsService.getSettings();
            await this.createPicker(settings);
        };
    
        if (this.accessToken === null) {
            // Prompt the user to select a Google Account and ask for consent to share their data
            // when establishing a new session.
            tokenClient.requestAccessToken({prompt: 'consent'});
        } else {
            // Skip display of account chooser and consent dialog for an existing session.
            tokenClient.requestAccessToken({prompt: ''});
        }
    }

    private async createPicker(settings: GoogleSettings) {
        const view = new google.picker.View(google.picker.ViewId.DOCS);
        view.setMimeTypes('application/vnd.google-apps.spreadsheet,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/x-zip');
        const picker = new google.picker.PickerBuilder()
            .enableFeature(google.picker.Feature.NAV_HIDDEN)
            .setDeveloperKey(settings.apiKey)
            .setAppId(settings.appId)
            .setOAuthToken(this.accessToken)
            .addView(view)
            .setCallback(this.pickerCallback.bind(this))
            .build();
        picker.setVisible(true);
    }

    private pickerCallback(data) {
        if (data.action === google.picker.Action.PICKED) {
            const document = data[google.picker.Response.DOCUMENTS][0];
            const fileId = document[google.picker.Document.ID];
            const fileName = document[google.picker.Document.NAME];
            const mimeType = document[google.picker.Document.MIME_TYPE];
            this.filePickedCallback(fileId, this.accessToken, fileName, mimeType);
        }
    }

}